import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { Add } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const EducationForm = ({ onChildData }) => {
  const [educationDetails, setEducationDetails] = useState([
    {
      degree: "",
      university: "",
      gpa: "",
      graduation_year: "",
      field_of_study: "",
      exams: [{ name: "", grade: "" }],
    },
  ]);

  const handleEduChange = (index, e) => {
    const { name, value } = e.target;
    const updatedEducation = [...educationDetails];
    updatedEducation[index][name] = value;
    setEducationDetails(updatedEducation);
    onChildData({ edu_information: updatedEducation });
  };

  const handleExamChange = (eduIndex, examIndex, e) => {
    const { name, value } = e.target;
    const updatedEducation = [...educationDetails];
    updatedEducation[eduIndex].exams[examIndex][name] = value;
    setEducationDetails(updatedEducation);
    onChildData({ edu_information: updatedEducation });
  };
  const addEducation = () => {
    setEducationDetails([
      ...educationDetails,
      {
        degree: "",
        university: "",
        gpa: "",
        graduation_year: "",
        field_of_study: "",
        exams: [{ name: "", grade: "" }],
      },
    ]);
  };
  const addExam = (index) => {
    const updatedEducation = [...educationDetails];
    updatedEducation[index].exams.push({ name: "", grade: "" });
    setEducationDetails(updatedEducation);
    onChildData({ edu_information: updatedEducation });
  };

  const removeExam = (eduIndex, examIndex) => {
    const updatedEducation = [...educationDetails];
    updatedEducation[eduIndex].exams = updatedEducation[eduIndex].exams.filter(
      (_, i) => i !== examIndex
    );
    setEducationDetails(updatedEducation);
    onChildData({ edu_information: updatedEducation });
  };

  const removeEducation = (index) => {
    const updatedEducation = educationDetails.filter((_, i) => i !== index);
    setEducationDetails(updatedEducation);
    onChildData({ edu_information: updatedEducation });
  };
  const formatEducationDetails = () => {
    let output = "education_details:\n";
    educationDetails.forEach((edu, index) => {
      output += `  - degree: "${edu.degree}"\n`;
      output += `    university: "${edu.university}"\n`;
      output += `    gpa: "${edu.gpa}"\n`;
      output += `    graduation_year: "${edu.graduation_year}"\n`;
      output += `    field_of_study: "${edu.field_of_study}"\n`;
      output += "    exam:\n";
      edu.exams.forEach((exam) => {
        output += `      ${exam.name}: "${exam.grade}"\n`;
      });
      if (index < educationDetails.length - 1) {
        output += "\n";
      }
    });
    return output;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedData = formatEducationDetails();
    console.log(formattedData);
  };

  return (
    <div>
      <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, pt: 0, pb: 2 }}>
        <Typography variant="h6" sx={{ display: "none" }} gutterBottom>
          Education
        </Typography>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h6">Education</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {educationDetails.map((edu, eduIndex) => (
                <Grid container spacing={2} key={eduIndex} sx={{ mb: 2 }}>
                  <Grid size={6}>
                    <Item>
                      <TextField
                        fullWidth
                        label="Degree"
                        name="degree"
                        size="small"
                        placeholder="Computer Science"
                        value={edu.degree}
                        onChange={(e) => handleEduChange(eduIndex, e)}
                        required
                      />
                    </Item>
                  </Grid>
                  <Grid size={6}>
                    <Item>
                      <TextField
                        fullWidth
                        label="University"
                        name="university"
                        placeholder="HKBU"
                        size="small"
                        value={edu.university}
                        onChange={(e) => handleEduChange(eduIndex, e)}
                        required
                      />
                    </Item>
                  </Grid>
                  <Grid size={6}>
                    <Item>
                      <TextField
                        fullWidth
                        label="GPA"
                        name="gpa"
                        placeholder="3.3/4"
                        size="small"
                        required
                        value={edu.gpa}
                        onChange={(e) => handleEduChange(eduIndex, e)}
                      />
                    </Item>
                  </Grid>
                  <Grid size={6}>
                    <Item>
                      <TextField
                        fullWidth
                        label="Graduation Year"
                        name="graduation_year"
                        placeholder="2023"
                        size="small"
                        value={edu.graduation_year}
                        onChange={(e) => handleEduChange(eduIndex, e)}
                        required
                      />
                    </Item>
                  </Grid>

                  <Grid size={9}>
                    <Item>
                      <TextField
                        fullWidth
                        label="Field of Study"
                        size="small"
                        placeholder="IT"
                        name="field_of_study"
                        value={edu.field_of_study}
                        onChange={(e) => handleEduChange(eduIndex, e)}
                        required
                      />
                    </Item>
                  </Grid>
                  <Grid size={3}>
                    <Item>
                      <IconButton
                        onClick={() => removeEducation(eduIndex)}
                        color="error"
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    </Item>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Exams
                    </Typography>
                    {edu.exams.map((exam, examIndex) => (
                      <Grid
                        container
                        spacing={2}
                        key={examIndex}
                        sx={{ mb: 2 }}
                      >
                        <Grid size={5}>
                          <Item>
                            <TextField
                              fullWidth
                              label="Exam Name"
                              name="name"
                              placeholder="Algorithms"
                              size="small"
                              value={exam.name}
                              onChange={(e) =>
                                handleExamChange(eduIndex, examIndex, e)
                              }
                              required
                            />
                          </Item>
                        </Grid>
                        <Grid size={5}>
                          <TextField
                            fullWidth
                            label="Grade"
                            placeholder="A"
                            name="grade"
                            size="small"
                            value={exam.grade}
                            onChange={(e) =>
                              handleExamChange(eduIndex, examIndex, e)
                            }
                            required
                          />
                        </Grid>
                        <Grid size={2}>
                          <Item>
                            <IconButton
                              onClick={() => removeExam(eduIndex, examIndex)}
                              color="error"
                            >
                              <DeleteForeverIcon />
                            </IconButton>
                          </Item>
                        </Grid>
                      </Grid>
                    ))}

                    <Button
                      variant="outlined"
                      onClick={() => addExam(eduIndex)}
                      startIcon={<Add />}
                      sx={{ mb: 2 }}
                    >
                      Add Exam
                    </Button>
                  </Grid>
                </Grid>
              ))}
              <Button
                variant="outlined"
                onClick={addEducation}
                startIcon={<Add />}
                sx={{ mb: 2 }}
              >
                Add Education
              </Button>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
};

export default EducationForm;
